import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "notifications-ph"
};
import { onUnmounted, reactive, watch } from "vue";
import { useNotification } from "naive-ui";
import { useUserStore } from "@/store/user";
import { createNotification } from "@/utils/notifications";
import Pusher from "pusher-js";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    var userStore = useUserStore();
    var notificationAPI = useNotification();
    var openNotifications = reactive({});
    var channel = null;

    var listen = function listen(authenticated) {
      var _userStore$user, _channel;

      var name = "user_".concat((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.id);

      if (!authenticated) {
        return unlisten();
      }

      if ((_channel = channel) !== null && _channel !== void 0 && _channel.subscribed) return;
      channel = pusher.subscribe(name);
      bind(channel);
    };

    var unlisten = function unlisten() {
      var _channel2, _channel3;

      (_channel2 = channel) === null || _channel2 === void 0 ? void 0 : _channel2.unsubscribe();
      (_channel3 = channel) === null || _channel3 === void 0 ? void 0 : _channel3.disconnect();
    };

    var bind = function bind(channel) {
      channel.bind("notification", onNew);
      channel.bind("notification_read", function (set) {
        return set.forEach(function (i) {
          userStore.updateNotificationRead(i.id, i.status);
          hide(i.id);
        });
      });
      channel.bind("notification_deletion", function (id) {
        userStore.deleteNotification(id);
        hide(id);
      });
    };

    var onNew = function onNew(notification) {
      userStore.notifications.push(notification);
      var instance = createNotification(notificationAPI, notification, {
        onClose: function onClose() {
          return delete openNotifications[notification.userNotificationId];
        }
      });
      if (!instance) return;
      openNotifications[notification.userNotificationId] = instance;
    };

    var hide = function hide(id) {
      if (!openNotifications[id]) return;
      openNotifications[id].destroy();
    };

    onUnmounted(function () {
      return unlisten();
    });
    watch(function () {
      return userStore.authenticated;
    }, listen, {
      immediate: true
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1);
    };
  }
});